import { Component, OnInit, AfterViewInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-text-config',
  templateUrl: './d-text-config.component.html',
  styles: []
})
export class DTextConfigComponent extends DynamicComponentBase {
  static KEY = 'd-text-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}
}
